import React, { FC } from 'react';

import { TextField, TextFieldProps } from '@material-ui/core';

interface CustomTextFieldProps {}

const CustomTextField: FC<CustomTextFieldProps & TextFieldProps> = (props) => {
  return <TextField variant="outlined" {...props} fullWidth />;
};

export default CustomTextField;
